export default __webpack_public_path__ + "static/instagram-e08d11c48e699b0fcf3edb5dc7f3490d.png";